import styled from 'styled-components'

export const ChartingEntryNote = styled.div`
    text-transform: none;
    margin-bottom: 8px;
`

export const ChartingEntryNoteFooter = styled.div`
    text-transform: capitalize;
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
`

export const ButtonGroup = styled.div`
    display: flex;
    gap: 3px;
`
